/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconErrorRed16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconErrorRed16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path fill="#fff" d="M5 2h6v12H5z" />
            <path
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm-1.29-4.297c0-.746.567-1.283 1.282-1.283.731 0 1.298.537 1.298 1.283A1.27 1.27 0 0 1 7.993 13c-.716 0-1.283-.552-1.283-1.297ZM7.465 3h1.07a.75.75 0 0 1 .747.812l-.394 4.729a.5.5 0 0 1-.498.458h-.78a.5.5 0 0 1-.498-.458l-.394-4.729A.75.75 0 0 1 7.465 3Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

const IconErrorRed24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconErrorRed24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path fill="#fff" d="M9 4h6v16H9z" />
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm-1.5-5.009c0-.867.659-1.491 1.491-1.491.85 0 1.509.624 1.509 1.491 0 .867-.659 1.509-1.509 1.509-.832 0-1.491-.642-1.491-1.509ZM11.172 6h1.656a.5.5 0 0 1 .5.522l-.307 7a.5.5 0 0 1-.5.478H11.48a.5.5 0 0 1-.5-.478l-.306-7a.5.5 0 0 1 .5-.522Z"
                fill="#D00"
            />
        </SVGContainer>
    );
});

export const IconErrorRed = forwardRef<SVGSVGElement, IconBaseProps>(function IconErrorRed(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconErrorRed16 {...iconProps} />;
        case '24':
            return <IconErrorRed24 {...iconProps} />;
        default:
            return <IconErrorRed24 {...iconProps} />;
    }
});
